export default "__VITE_ASSET__Btp5b$2d__"